import React from 'react';
import Icon from '../../../components/AppIcon';

const FooterSection = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    product: [
      { label: 'Возможности', href: '#features' },
      { label: 'Цены', href: '#pricing' },
      { label: 'Интеграции', href: '#' },
      { label: 'API', href: '#' }
    ],
    company: [
      { label: 'О нас', href: '#' },
      { label: 'Блог', href: '#' },
      { label: 'Карьера', href: '#' },
      { label: 'Контакты', href: '#' }
    ],
    support: [
      { label: 'База знаний', href: '#' },
      { label: 'Документация', href: '#' },
      { label: 'Поддержка', href: '#' },
      { label: 'Статус системы', href: '#' }
    ],
    legal: [
      { label: 'Политика конфиденциальности', href: '#' },
      { label: 'Условия использования', href: '#' },
      { label: 'Обработка данных', href: '#' },
      { label: 'Безопасность', href: '#' }
    ]
  };

  const socialLinks = [
    { icon: 'Mail', href: 'mailto:info@spheretech.it.com', label: 'Email' },
    { icon: 'Phone', href: 'tel:+77066862507', label: 'Телефон' },
    { icon: 'MessageCircle', href: '#', label: 'Telegram' },
    { icon: 'Linkedin', href: '#', label: 'LinkedIn' }
  ];

  return (
    <footer className="relative py-8 sm:py-12 md:py-16 overflow-hidden border-t border-border">
      <div className="absolute inset-0 bg-gradient-to-b from-card to-background" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-6 sm:gap-8 mb-8 sm:mb-12">
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-primary to-accent flex items-center justify-center">
                <span className="text-black font-bold text-xl">С</span>
              </div>
              <span className="text-lg sm:text-xl font-bold text-foreground">СФЕРА CRM</span>
            </div>
            <p className="text-xs sm:text-sm text-muted-foreground mb-4 sm:mb-6 max-w-xs">
              Единая CRM-платформа нового поколения с ИИ-автоматизацией для трансформации вашего бизнеса
            </p>
            <div className="flex items-center space-x-3">
              {socialLinks?.map((social, index) => (
                <a
                  key={index}
                  href={social?.href}
                  className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg glassmorphism flex items-center justify-center hover:bg-primary/10 hover:border-primary/20 transition-all"
                  aria-label={social?.label}
                >
                  <Icon name={social?.icon} size={16} className="sm:w-[18px] sm:h-[18px]" color="var(--color-muted-foreground)" />
                </a>
              ))}
            </div>
          </div>

          <div className="sm:col-span-1">
            <h4 className="text-xs sm:text-sm font-bold text-foreground mb-3 sm:mb-4">Продукт</h4>
            <ul className="space-y-1.5 sm:space-y-2">
              {footerLinks?.product?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.href}
                    className="text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors inline-block"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="sm:col-span-1">
            <h4 className="text-xs sm:text-sm font-bold text-foreground mb-3 sm:mb-4">Компания</h4>
            <ul className="space-y-1.5 sm:space-y-2">
              {footerLinks?.company?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.href}
                    className="text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors inline-block"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="sm:col-span-1">
            <h4 className="text-xs sm:text-sm font-bold text-foreground mb-3 sm:mb-4">Поддержка</h4>
            <ul className="space-y-1.5 sm:space-y-2">
              {footerLinks?.support?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.href}
                    className="text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors inline-block"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="sm:col-span-2 lg:col-span-1">
            <h4 className="text-xs sm:text-sm font-bold text-foreground mb-3 sm:mb-4">Правовая информация</h4>
            <ul className="space-y-1.5 sm:space-y-2">
              {footerLinks?.legal?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.href}
                    className="text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors inline-block"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-6 sm:pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0 gap-4">
            <div className="text-xs sm:text-sm text-muted-foreground text-center md:text-left">
              © {currentYear} СФЕРА CRM. Все права защищены.
            </div>
            
            <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4 md:gap-6">
              <div className="flex items-center space-x-1.5 sm:space-x-2">
                <Icon name="Shield" size={14} className="sm:w-4 sm:h-4" color="var(--color-success)" />
                <span className="text-[10px] sm:text-xs text-muted-foreground whitespace-nowrap">SOC 2 Type II</span>
              </div>
              <div className="flex items-center space-x-1.5 sm:space-x-2">
                <Icon name="Lock" size={14} className="sm:w-4 sm:h-4" color="var(--color-success)" />
                <span className="text-[10px] sm:text-xs text-muted-foreground whitespace-nowrap">GDPR</span>
              </div>
              <div className="flex items-center space-x-1.5 sm:space-x-2">
                <Icon name="Award" size={14} className="sm:w-4 sm:h-4" color="var(--color-success)" />
                <span className="text-[10px] sm:text-xs text-muted-foreground whitespace-nowrap">ISO 27001</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;